import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Events } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { GlobalVariable } from '../global';

@Injectable()
export class MenteeGroupData {
  private apiUrl = GlobalVariable.BASE_API_URL; //get api url
  constructor(
    public events: Events,
    public storage: Storage,
    public http: HttpClient
  ) { }

  createMenteeGroup(formData) {
    return this.http.post(this.apiUrl + 'mentee-group', formData)
  }

  getMenteeGroup() {
    return this.http.get(this.apiUrl + 'mentee-group')
  }

  addMentorToMenteeGroup(formData) {
    return this.http.post(this.apiUrl + 'add-mentor-to-mentee-group', formData)
  }

  addMenteeToMenteeGroup(formData) {
    return this.http.post(this.apiUrl + 'add-mentee-to-mentee-group', formData)
  }

  getMenteeList(groupid) {
    return this.http.get(this.apiUrl + `mentee-list-by-group-id?groupid=${groupid}`)
  }

  getMenteeByMentor() {
    return this.http.get(this.apiUrl + 'mentee-by-mentor')
  }

  getMenteeByAdmin() {
    return this.http.get(this.apiUrl + 'mentee-by-admin')
  }

  getMentorByAdmin() {
    return this.http.get(this.apiUrl + 'mentor-by-admin')
  }

  getMentorByMentee(userid) {
    return this.http.get(this.apiUrl + `get-mentor-by-menteeid?userid=${userid}`)
  }

  deleteMentee(item) {
    return this.http.post(this.apiUrl + `delete-mentee`, item);
  }
}



// WEBPACK FOOTER //
// ./src/providers/mentee-group-data.ts